import { defineStore } from 'pinia'

type State = {
  currentDropdownId: string
}

export const useDropdown = defineStore('dropdown', {
  state: (): State => {
    const initialState: State = { currentDropdownId: '' }

    return initialState
  },
  actions: {
    toggleDropdown(dropdownId: string) {
      // No two dropdowns can be open at the same time
      if (dropdownId === this.currentDropdownId) {
        this.currentDropdownId = ''
      } else {
        this.currentDropdownId = dropdownId
      }
    },

    closeDropdown() {
      this.currentDropdownId = ''
    },
  },
})
